import api from "../utils/api";

export const loginService = {
  login: async (email, password) => {
    try {
      const res = await api.post("/login", {
        email,
        password,
      });

      const data = res.data;

      if (!data?.token || !data?.user) {
        throw new Error("Invalid login response");
      }

      localStorage.setItem("inv_panel_token", data.token);
      localStorage.setItem("inv_panel_user", JSON.stringify(data.user));

      return data;
    } catch (err) {
      if (err.response) {
        throw new Error(err.response?.data?.message || "Login failed");
      }

      throw new Error("Network error");
    }
  },
};
